import { HttpInterceptorFn } from '@angular/common/http';

const ACCESS_TOKEN_KEY = 'wm_access_token';
const EXPIRES_AT_KEY = 'wm_token_expires_at';

function getValidToken(): string | null {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (!token) return null;
  const raw = localStorage.getItem(EXPIRES_AT_KEY);
  if (!raw) return null;
  const expiry = new Date(raw);
  if (isNaN(expiry.getTime()) || expiry <= new Date()) return null;
  return token;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getValidToken();
  return next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req);
};
